import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedComics() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">编辑精选，不容错过的优质韩漫</p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1 transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredComics.slice(0, 8).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫大全免费阅读`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-xs px-2 py-1 rounded-full font-medium whitespace-nowrap ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-accent-400">
                    <i className="ri-star-fill text-xs"></i>
                    <span className="text-xs text-background-50 font-medium">{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                {comic.author} · 共{comic.chapters}话
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}